"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var configuration = props.configuration,
      style = props.style,
      onCallback = props.onCallback,
      restProps = __rest(props, ["configuration", "style", "onCallback"]);

  var _a = configuration || {},
      articleList = _a.articleList,
      title = _a.title,
      titleBgUrl = _a.titleBgUrl;

  return /*#__PURE__*/_react["default"].createElement("div", __assign({}, restProps, {
    ref: ref,
    className: 'flex-dynamic-details-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-dynamic-details-container-children'
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'content-article-block-class'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'title-block-class',
    style: titleBgUrl ? {
      backgroundImage: "url(" + titleBgUrl + ")"
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("span", null, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'article-list-class'
  }, articleList && articleList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("article", {
      onClick: function onClick() {
        onCallback && onCallback(item);
      }
    }, item.titleBgUrl && /*#__PURE__*/_react["default"].createElement("div", {
      className: 'article-list-class-title-bg'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: item.titleBgUrl
    })), /*#__PURE__*/_react["default"].createElement("h3", {
      className: (0, _classnames["default"])('', {
        'article-title-hover': onCallback
      })
    }, item.title), /*#__PURE__*/_react["default"].createElement("div", null, item.content, " ")), articleList.length - 1 !== index ? /*#__PURE__*/_react["default"].createElement("div", {
      className: 'dynamic-hr-class'
    }) : null);
  })))));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = Thumbnail;
exports["default"] = _default;